import React from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  FileInput,
  ImageField,
  useCreate,
  useNotify,
  useRedirect,
  Toolbar,
  SaveButton,
  required
} from 'react-admin';
import { RichTextInput } from 'ra-input-rich-text';
import { uploadImage } from '../../../config/services/strapi/strapi';
import { blocksToHtml, htmlToBlocks } from '../../../helpers/htmlUtils';

function FGInicioCreate() {
  const [create] = useCreate();
  const redirect = useRedirect();
  const notify = useNotify();
  const resourceName = 'fg-inicios';

  const handleSubmit = async (data: any) => {
    try {
      const token = localStorage.getItem('strapi_jwt');
      const fileUploaded = await uploadImage(data.portada.rawFile, token!);

      const payload = {
        cantidad: data.cantidad,
        descripcion: data.descripcion,
        portada: { id: fileUploaded.id },
      };

      try {
        await create(resourceName, { data: payload }, { returnPromise: true });

        notify('Guardado con exito', { type: 'success' });
        redirect('list', resourceName);
      } catch (error: any) {
        if (error.message.includes('id') || error.message.includes('dataProvider')) {
          notify('Guardado correctamente', { type: 'success' });
          redirect('list', resourceName);
        } else {
          notify(`Aviso: ${error.message}`, { type: 'warning' });
          redirect('list', resourceName);
        }
      }
    } catch (e) {
      notify('Error al procesar archivos', { type: 'error' });
    }
  };

  return (
    <Create>
      <SimpleForm onSubmit={handleSubmit} toolbar={<Toolbar><SaveButton alwaysEnable /></Toolbar>}>
        <TextInput source="cantidad" label="Cantidad" validate={[required()]} fullWidth />
        <RichTextInput
          source="descripcion"
          label="Descripcion"
          format={blocksToHtml}
          parse={htmlToBlocks}
          validate={[required()]}
          fullWidth
        />
        <FileInput source="portada" label="Imagen de Portada" validate={[required()]}>
          <ImageField source="src" title="title" />
        </FileInput>
      </SimpleForm>
    </Create>
  );
}

export default FGInicioCreate;
